import {useIntersectionObserver} from 'platform/components';
import {getPixelsFromRem, getSize, Integer} from 'platform/foundation';
import {cn, cva} from 'platform/shared';
import {match} from 'ts-pattern';

import {ReactNode} from 'react';

import {useBoolean} from 'shared/web';

interface SlideshowActionWrapperProps {
  children: ReactNode;
  position: 'right' | 'left';
  spacingFromEdge?: Integer;
  isHidden?: boolean;
}

const wrapperVariants = cva(
  'pointer-events-none absolute top-0 z-[var(--z-lightbox-actions)] h-full'
);
const stickyVariants = cva('sticky top-2 py-2 transition-opacity duration-150 ease-out');

export function SlideshowActionsWrapper(props: SlideshowActionWrapperProps) {
  const [isVisible, setVisible, setHidden] = useBoolean(true);
  const observedElementsRefs = useIntersectionObserver(
    (info) => {
      if (info[0].isIntersecting) {
        setVisible();
      } else {
        setHidden();
      }
    },
    {threshold: 1, rootMargin: `-${getPixelsFromRem(2)}px`}
  );

  const leftStyle = match(props.position)
    .with('left', () => getSize(props.spacingFromEdge ?? 0))
    .otherwise(() => 'auto');
  const rightStyle = match(props.position)
    .with('right', () => getSize(props.spacingFromEdge ?? 0))
    .otherwise(() => 'auto');

  return (
    <div className={cn(wrapperVariants())} style={{left: leftStyle, right: rightStyle}}>
      <div
        ref={(ref) => {
          observedElementsRefs.current[0] = ref;
        }}
        className={cn(stickyVariants())}
        style={{opacity: isVisible ? 1 : 0}}
      >
        {props.children}
      </div>
    </div>
  );
}
